import { IEntity } from './IEntity';

export const resourceNameCompletedCalendarEventId = `completedcalendareventid`;

export interface ICompletedCalendarEventId extends IEntity {
	eventid: string;
}
